import { EnumSchema } from '../metadata-schema';

export const BovenbouwsuccesUitzondering: EnumSchema = {
	"type": "string",
	"title": "BovenbouwsuccesUitzondering",
	"enum": [
		"Regulier bovenbouwsucces",
		"Geen bovenbouw",
		"Geen relevante plaatsing",
		"Geen 1-oktoberplaatsing",
		"Extraneus",
		"Tussentijdse instroom",
		"Doorstroom hoger onderwijs zonder uitslag",
		"Overgang naar praktijkonderwijs",
		"Uitstroom speciaal onderwijs",
		"Uitgesloten van ROD-communicatie",
		"VAVO leerling",
		"Internationale leerling",
		"Nieuwkomer"
	]
};
